// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__22mkm","description":"PatientConsentPreview_description__i6zva"};